// Used in page-header.component.html and tiles.component.ts

import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: "feedback-dialog",
    templateUrl: "./feedback-dialog.component.html",
    styleUrls: ["./feedback-dialog.component.scss"],
    standalone: false
})
export class FeedbackDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<FeedbackDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    close(): void {
        this.dialogRef.close(1);
    }
}
